import { render, staticRenderFns } from "./AttributesSettings.vue?vue&type=template&id=59aad70d"
import script from "./AttributesSettings.vue?vue&type=script&lang=js"
export * from "./AttributesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports